// extracted by mini-css-extract-plugin
export default {"mgidDesktopWrapper":"DkX7M","mgidMobileWrapper":"l8rz5"};